<app-gc-header
  [titleString]="'videoInstructionTitle' | translate"
  [iconName]="'youtube'"
/>
<gc-button
  [icon]="'chevronLeft'"
  [iconPosition]="'left'"
  [variant]="'plain'"
  (clicked)="goToHomePage()"
  >{{ 'backButtonText' | translate }}
</gc-button>

<div class="video-instruction">
  <div class="searchbar">
    <gc-input-field
      [placeholder]="'Search'"
      [icon]="'magnifyingGlass'"
      (changed)="setSearchInputString($event)"
    />

    @if (noResultsFound()) {
      <gc-text [variant]="'paragraph'"
        >No results found for '{{ searchInputString() }}'</gc-text
      >
    }
  </div>

  @for (group of filteredVideoSections(); track group.section) {
    <section class="section">
      <gc-text [variant]="'subHeading'">
        {{ group.section }}
      </gc-text>
    </section>
    <div class="grid">
      @for (video of group.videos; track video.url) {
        <app-video-instruction-card [instruction]="video" />
      }
    </div>
  }
</div>
